import { transformLineItemToBE } from '../transformLineItemToBE'
import { ALLOCATION } from '../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/InventoryAccessAndAllocationSection/SubAllocationTables/fields'

export const formatPercentageSingleAllocationLineItem = ({ inventory, values, right, campaignId, currency }) => {
  const units = right[ALLOCATION]
  // In single allocation right all inventory items have the same price, so we can take the price from the first inventory item
  const microAmount = inventory[0].prices[right.billing_event] || 0

  return transformLineItemToBE({
    inventory,
    values,
    campaignId,
    units,
    microAmount,
    right,
    currency
  })
}
